export function formatAddress(address1?: string, city?: string, state?: string): string {
  const parts: string[] = [];

  if (address1 && address1.trim().length > 0) {
    parts.push(address1.trim());
  }

 
  if (city && city.trim()) {
    parts.push(city.trim());
  }

  
  if (state && state.trim()) {
    let stateAbbr = state
      .split(/\s+/) 
      .map(word => word.charAt(0)) 
      .join("") 
      .toUpperCase(); 
    
    if (stateAbbr === 'S') {
      stateAbbr = 'SC';
    }
    
    parts.push(stateAbbr);
  }

  return parts.join(', ');
}

// Example Usage:
// console.log(formatAddress("185 Lockwood Dr", "Charleston", "South Carolina")); 
// Output: "185 Lockwood Dr, Charleston, S"

